import { DatePicker, Pagination, Image, Spin } from "antd";
import ReportTable from "./ReportTable";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { PAGINATION_PAGE_OPTIONS } from "../../../constant/constants";

export default function OrderReportArchivedComponent({
  reportData,
  handleFilterApply,
  handleArchived,
  page,
  perPage,
  setPerPage,
  total,
  handlePageChange,
  loadingArchive,
  handleFromDate,
  handleToDate,
  fromDateTime,
  toDateTime,
  handleClearFilter
}) {
  dayjs.extend(isSameOrBefore);

  return (
    <section>
      {/* filters */}
      <div className="flex items-center space-between w-full mt-[20px] mb-[31px]">
        <div className="flex items-center space-x-[15px] items-center w-full">
          <div className="h-[48px] w-[18%]">
            <DatePicker
              className={"h-full w-full"}
              format="YYYY-MM-DD"
              value={fromDateTime ? dayjs(fromDateTime) : null}
              onChange={handleFromDate}
              placeholder="From Date"
              needConfirm
            />
          </div>
          <div className="h-[48px] w-[18%]">
            <DatePicker
              className={"h-full w-full"}
              format="YYYY-MM-DD"
              value={toDateTime ? dayjs(toDateTime) : null}
              onChange={handleToDate}
              placeholder="To Date"
              needConfirm
            />
          </div>

          <div className="flex items-center space-x-[20px] h-[48px] w-[200px]">
            <button
              className="w-full h-full bg-black text-[14px] font-bold leading-[16px] text-white rounded-[5px] w-[50%]"
              onClick={handleClearFilter}
            >
              Clear
            </button>
            <button
              className="w-full h-full bg-[#FCBD10] text-[14px] font-bold leading-[16px] text-black rounded-[5px] w-[50%]"
              onClick={handleFilterApply}
            >
              Apply
            </button>
          </div>
        </div>
        <div className="flex items-center space-x-[20px] h-[48px] w-[200px]">
          <button
            className="w-full h-full bg-[#2EC114] text-[14px] font-bold leading-[16px] text-black rounded-[5px] w-[50%] text-center"
            onClick={handleArchived}
          >
            {loadingArchive ? (
              <Spin size="small" className="black-spinner" />
            ) : (
              <div className="flex items-center justify-center gap-x-[14.79px]">
                <Image
                  src={"/images/icons/archive.svg"}
                  preview={false}
                  alt="archive"
                  width={16.99}
                  height={26.53}
                />
                <span>Archived</span>
              </div>
            )}
          </button>
        </div>
      </div>

      {/* sales report table */}
      <div>
        <ReportTable
          data={reportData}
          context={"orders-archived"}
          page={page}
          perPage={perPage}
          isLoading={loadingArchive}
        />
        <div className="mt-[20px] mb-[50px] report-pagination relative custom-pagination-options">
          <Pagination
            showSizeChanger
            onChange={handlePageChange}
            onShowSizeChange={(current, size) => {
              setPerPage(size);
            }}
            current={page}
            pageSize={perPage}
            total={total}
            pageSizeOptions={PAGINATION_PAGE_OPTIONS}
            locale={{ items_per_page: "" }}
            showQuickJumper={false}
          />

          <div
            className="absolute h-[48px] flex items-center space-x-[40px] 
          top-0 right-[122px] text-[18px] font-medium text-[#7D7D7D] mr-3"
          >
            <div>Total: {total}</div>
            <div>Row </div>
          </div>
        </div>
      </div>
    </section>
  );
}
